// packages/react/use-previous/src/usePrevious.tsx
import * as React from "react";
function usePrevious(value) {
  var ref = React.useRef({
    value: value,
    previous: value
  });
  return React.useMemo(function () {
    if (ref.current.value !== value) {
      ref.current.previous = ref.current.value;
      ref.current.value = value;
    }
    return ref.current.previous;
  }, [value]);
}
export { usePrevious };